import React from "react";

export const defaultMessageContext = {
  show: false,
  title: null,
  content: null,
  yesLabel: null,
  noLabel: null,
  onYes: null,
  onNo: null,
  toggle(params) {},
};

export const MessageContext = React.createContext(defaultMessageContext);
